// File: /js/pages/quiz-create.js

import { setupQuizAnswers } from '../shared/extensions/quizAnswers-create.js';
import { initMultipleChoice } from '../shared/quiz/multiple-choice-toggle.js';

export function setupAll() {
  // 1) Wire add/delete/reorder + richtext syncing for answers
  setupQuizAnswers();

  // 2) Enforce single vs multiple correct answers + keep at least one correct
  //    Works for both normal quizzes and module_quiz (shared behavior).
  initMultipleChoice(document);
}

// Auto-run if directly loaded on page
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupAll);
} else {
  setupAll();
}
